<template>
    <el-dialog
        @open="handleOpen"
        :visible.sync="visible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        custom-class="dialogForm"
        class="measDialog"
        width="80%"
        height="90%"
        min-width="800px"
        title="课程详情"
    >
        <el-scrollbar class="dialogContentScroll">
            <div class="course-details__wrap">
                <div class="course-base-info">
                    <h2 class="course-name">{{ courseBaseInfo.name || '--' }}</h2>
                    <h3 class="class-name">{{ courseBaseInfo.classname || '--' }}</h3>
                    <ul class="course-data">
                        <li class="course-data-item">
                            <div class="course-data-item__value">{{ courseBaseInfo.totalstudentcount }}</div>
                            <div class="course-data-item__label">学员总数</div>
                        </li>
                        <li class="course-data-item">
                            <div class="course-data-item__value">{{ `${courseBaseInfo.finishperiodcount}/${courseBaseInfo.periodcount}` }}</div>
                            <div class="course-data-item__label">课程进展</div>
                        </li>
                        <li class="course-data-item">
                            <div class="course-data-item__value">{{ courseBaseInfo.studystudentcount }}</div>
                            <div class="course-data-item__label">总学习人数</div>
                        </li>
                        <li class="course-data-item">
                            <div class="course-data-item__value">{{ courseBaseInfo.finishcoursecount }}</div>
                            <div class="course-data-item__label">完课人数</div>
                        </li>
                        <li class="course-data-item">
                            <div class="course-data-item__value">{{ courseBaseInfo.finishrate }}</div>
                            <div class="course-data-item__label">完课率</div>
                        </li>
                    </ul>
                </div>
                <el-tabs @tab-click="handleTabChange" v-model="activeTabName">
                    <el-tab-pane label="考勤信息" name="attendanceInfo">
                        <AttendanceInfo ref="attendanceInfo" :code="code" />
                    </el-tab-pane>
                    <el-tab-pane label="学员信息" name="studentInfo">
                        <StudentInfo :course-code="code" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-scrollbar>
    </el-dialog>
</template>
<script>
import AttendanceInfo from './attendanceInfo.vue'
import StudentInfo from './studentInfo.vue'
import { getCourseTopInfo } from '@/api/measApi/studyManagement'
export default {
    components: {
        AttendanceInfo,
        StudentInfo,
    },
    data: () => ({
        activeTabName: 'attendanceInfo',
        courseBaseInfo: {},
    }),
    props: {
        // 对话框可见性
        visible: {
            require: false,
            type: Boolean,
            default: false,
        },
        code: {
            require: true,
            type: String,
        },
    },
    methods: {
        handleTabChange(e) {
            e.$children[0].init()
        },
        // 获取课程顶部信息
        async getCourseTopInfo() {
            const res = await getCourseTopInfo({ code: this.code })
            if (res.code === '000') {
                this.courseBaseInfo = res.data
            }
        },
        // 对话框打开时
        handleOpen() {
            this.$refs.attendanceInfo.init()
            this.getCourseTopInfo()
        },
        // 对话框关闭时
        handleClose() {
            this.activeTabName = 'attendanceInfo'
            this.$emit('update:visible', false)
        },
    },
}
</script>
<style lang="scss" scoped>
.course-details__wrap {
    padding: 0 0 20px;
}
::v-deep .el-dialog .el-dialog__body {
    height: calc(100% - 51px) !important;
}
.course-base-info {
    padding: 20px;
    border-radius: 4px;
    background-color: #f6f7fb;
}
.course-name {
    font-size: 16px;
    color: #333;
}
.class-name {
    margin-top: 6px;
    font-size: 12px;
    line-height: 17px;
    color: #333;
}
.course-data {
    margin-top: 27px;
    display: flex;
    flex-wrap: wrap;
}
.course-data-item {
    flex-shrink: 0;
}
.course-data-item:not(:last-of-type) {
    margin-right: 60px;
    @media screen and (max-width: 850px) {
        margin-right: 20px;
    }
}
.course-data-item > div {
    text-align: center;
}
.course-data-item__value {
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    color: #333;
    font-weight: 600;
}
.course-data-item__label {
    margin-top: 8px;
    font-size: 12px;
    line-height: 17px;
    color: #666;
}
::v-deep .el-tabs {
    .el-tabs__item {
        padding: 0 20px !important;
        &.is-active {
            color: #4d5560 !important;
        }
        &:hover {
            color: #4d5560;
        }
        .el-tabs__nav-wrap::after {
            background-color: #f6f7fb;
        }
    }
}
</style>
